// /images DataGrid 컬럼 정의.
// flex 전면 제거 → width + minWidth 고정. 넘치는 컬럼은 그리드 내부 가로 스크롤로 처리.

import React from "react";
import { Link } from "react-router-dom";
import { EditButton } from "@refinedev/mui";
import type { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import { StatusChip, OverflowTooltip } from "components/list";
import { IImage } from "../interfaces";
import { uploadStatusMeta, resolveStatusMeta } from "./imagesStatus";

// 셀 내 링크는 프라이머리 토큰(라이트/다크 공용)
const linkStyle: React.CSSProperties = {
  textDecoration: "underline",
  fontWeight: 600,
  color: "var(--color-primary)",
};

// category 값 → 연관 Entity 라우트 경로 (기존 매핑 유지)
const categoryToRoute = (category: string): string => {
  switch (category) {
    case "USER":
      return "users";
    case "CHILD":
      return "children";
    case "CENTER":
      return "centers";
    case "POST":
      return "posts";
    case "BOARD":
      return "boards";
    case "PRESENTATION":
      return "presentations";
    default:
      return "images";
  }
};

export const imagesColumns: GridColDef<IImage>[] = [
  { field: "id", headerName: "ID", type: "number", width: 84, minWidth: 72, align: "center", headerAlign: "center" },
  {
    field: "name",
    headerName: "이름",
    width: 320,
    minWidth: 200,
    renderCell: (params: GridRenderCellParams) => (
      <OverflowTooltip value={params.value}>
        <Link to={`/images/show/${params.row.id}`} style={linkStyle}>
          {params.value}
        </Link>
      </OverflowTooltip>
    ),
  },
  { field: "extension", headerName: "확장자", type: "string", width: 96, minWidth: 88, align: "center", headerAlign: "center" },
  { field: "category", headerName: "연관Entity", type: "string", width: 140, minWidth: 110, align: "center", headerAlign: "center" },
  {
    field: "targetId",
    headerName: "연관Entity ID",
    type: "string",
    width: 128,
    minWidth: 110,
    align: "center",
    headerAlign: "center",
    renderCell: (params: GridRenderCellParams) => (
      <OverflowTooltip value={params.value}>
        <Link
          to={`/${categoryToRoute(params.row.category)}/show/${params.value}`}
          style={linkStyle}
        >
          {params.value}
        </Link>
      </OverflowTooltip>
    ),
  },
  {
    field: "uploadStatus",
    headerName: "업로드상태",
    type: "string",
    width: 120,
    minWidth: 100,
    align: "center",
    headerAlign: "center",
    renderCell: (params: GridRenderCellParams) => {
      const meta = resolveStatusMeta(uploadStatusMeta, params.value);
      return <StatusChip label={meta.label} color={meta.color} />;
    },
  },
  { field: "createdDate", headerName: "생성일", type: "string", width: 170, minWidth: 140, align: "center", headerAlign: "center" },
  {
    field: "actions",
    headerName: "Actions",
    width: 100,
    minWidth: 90,
    sortable: false,
    renderCell: (params: GridRenderCellParams) => (
      <EditButton hideText recordItemId={params.row.id} />
    ),
  },
];
